import { formatCents } from "@budgeter/shared";
import { cn } from "./cn";

export type BalanceTone = "pos" | "low" | "neg" | "owed" | "zero";

/**
 * Funded is sage, nearly spent amber, overspent brick red (SPEC §11.1). A carried negative
 * ("owed", e.g. reimbursable business spending) is a dashed outline.
 */
export function balanceTone(available: number, budgeted: number, carry: boolean): BalanceTone {
  if (available < 0) {
    return carry ? "owed" : "neg";
  }
  if (available === 0) {
    return "zero";
  }
  return budgeted > 0 && available < budgeted * 0.1 ? "low" : "pos";
}

const toneClass: Record<BalanceTone, string> = {
  pos: "bg-pos-bg text-pos",
  low: "bg-low-bg text-low",
  neg: "bg-neg-bg text-neg",
  owed: "bg-transparent text-neg border-[1.5px] border-dashed border-neg-line py-[2px] px-[9px]",
  zero: "bg-zero-bg text-zero",
};

export function BalancePill({
  cents,
  tone,
  className,
}: {
  cents: number;
  tone: BalanceTone;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "num inline-block min-w-16 rounded-full px-2.5 py-[3px] text-right text-[13.5px] font-semibold",
        toneClass[tone],
        className,
      )}
    >
      {formatCents(cents)}
    </span>
  );
}
